import React from 'react';

const DownloadFreePNG = ({
  slug,
  collection,
  url,
  onBeforeAction,
  onActionComplete,
}) => {
  const handleDownload = async (e) => {
    e.preventDefault();

    // before‑callback
    if (typeof onBeforeAction === 'function' && onBeforeAction() === false) {
      return;
    }

    // формируем ссылку, если её не передали
    let downloadUrl = url;
    if (!downloadUrl) {
      if (collection === 'basic3d') {
        downloadUrl = `https://icons-pbl.davooda.com/basic3d-icons/png-512px/${slug}.png`;
      } else {
        console.error('Unknown collection for DownloadFreePNG');
        return;
      }
    }

    try {
      // 1. забираем файл как Blob (убирает CORS‑ограничения на атрибут download)
      const resp = await fetch(downloadUrl, { mode: 'cors' });
      if (!resp.ok) throw new Error(`HTTP‑error ${resp.status}`);
      const blob = await resp.blob();

      // 2. создаём временный object URL и «скрытую» ссылку
      const objectUrl = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = objectUrl;
      link.setAttribute('download', `${slug}-512.png`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(objectUrl);          // очищаем память

      // after‑callback
      if (typeof onActionComplete === 'function') onActionComplete();
    } catch (err) {
      console.error('Error downloading PNG:', err);
    }
  };

  return (
    <button
      onClick={handleDownload}
      className="block w-full text-center whitespace-nowrap px-3 py-3 bg-black text-white font-bold shadow-md rounded-md min-h-[60px]"
    >
      Download PNG for free
    </button>
  );
};

export default DownloadFreePNG;
